export default __webpack_public_path__ + "static/media/yuri.bf5ca36c.jp2";